import { differenceInDays } from "date-fns";

import { InventoryStatus } from "../../utils/constants";

export const ageRenderer = (record) => {
  if (!record && !record.inventory) return "";
  // record.inventory used in inventory list by location (inventoryItem)
  const inventory = record.inventory || record;
  const status = record.status || inventory.status;
  const dateReceived = record.receivedAt || inventory.receivedAt;
  const dateDepleted = record.depletedAt || inventory.depletedAt;
  let daysDIff = "";

  if (status === InventoryStatus.STORED) {
    // calculate age
    daysDIff = differenceInDays(new Date(), new Date(dateReceived));
  } else if (status === InventoryStatus.SHIPPED) {
    // calculate turn days
    daysDIff = differenceInDays(new Date(dateDepleted), new Date(dateReceived));
  }

  return daysDIff;
};
